import { render, staticRenderFns } from "./apiget_ponents.vue?vue&type=template&id=65b4a355"
import script from "./apiget_ponents.vue?vue&type=script&lang=js"
export * from "./apiget_ponents.vue?vue&type=script&lang=js"
import style0 from "./apiget_ponents.vue?vue&type=style&index=0&id=65b4a355&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports